<template>
    <div class="alert" :class="`alert-${color}`"><slot /></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CAlert',
    props: {
        color: { type: String, default: 'primary' },
    },
});
</script>
